import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";

// 1. Define route components.
// These can be imported from other files

// 2. Define some routes
// Each route should map to a component.
// We'll talk about nested routes later.
const publicRoutes = [
  {
    path: "/",
    name: "home",
    // component: () => import("@components/VideoBrowser.vue"),
    component: () => import("@views/Home.vue"),
    beforeEnter: async (): Promise<void> => {},
  },
  {
    name: "share",
    path: "/share/:videoToken",
    props: true,
    component: () => import("@public/SharePage.vue"),
  },
  {
    name: "player",
    path: "/embed/:videoToken/:language?",
    props: true,
    component: () => import("@public/PublicPlayer.vue"),
  },
  {
    name: "guide",
    path: "/guide/:videoToken",
    props: true,
    component: () => import("@public/PublicGuide.vue"),
  },
  // {
  //   path: "/:pathMatch(.*)*",
  //   redirect: "/",
  //   // component: NotFound,
  // },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHistory(), // This relies on the server to handle our dynamic URLs
  // history: createWebHashHistory(), // TODO: replace with root based history
  // routes: publicRoutes,
  routes: publicRoutes,
});

export default router;
